/*
 * bc-money
 *
 * Shared currency formatter for the bc-*.js scripts. Before this existed the
 * same Intl.NumberFormat construction (locale + currency, en/USD fallback)
 * was hand-rolled in six scripts and had already drifted (missing try/catch,
 * navigator.language vs data-locale, undefined locale). One implementation,
 * one drift surface.
 *
 * Exposes `window.bcMoney`:
 *   - formatter(locale, currency) → Intl.NumberFormat (cached per pair;
 *     falls back to en/USD if the inputs are invalid)
 *   - formatCents(cents, currency, locale) → "$12.34"
 *
 * Loaded (defer) by each consumer's Liquid before its own script — same
 * pattern as bc-weight-format / bc-variant-resolve. IIFE-guarded so
 * duplicate loads are no-ops.
 */
(() => {
  if (window.bcMoney) return;

  const cache = new Map();

  function formatter(locale, currency) {
    const loc = locale || document.documentElement.lang || 'en';
    const cur = currency || 'USD';
    const key = `${loc}|${cur}`;
    let fmt = cache.get(key);
    if (!fmt) {
      try {
        fmt = new Intl.NumberFormat(loc, { style: 'currency', currency: cur });
      } catch (_e) {
        fmt = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' });
      }
      cache.set(key, fmt);
    }
    return fmt;
  }

  function formatCents(cents, currency, locale) {
    return formatter(locale, currency).format((cents || 0) / 100);
  }

  window.bcMoney = { formatter, formatCents };
})();
